import calculatorApi from '../services/calculatorApi';

/**
 * Trading Hours Service
 * Handles all trading hours operations via the calculator API
 */
const tradingHoursService = {
  /**
   * Save trading hours configuration
   * @param {Object} data - Trading hours data
   */
  saveTradingHours: async (data) => {
    try {
      console.log('Saving trading hours to API:', data);
      const response = await calculatorApi.updateTradingHours(data);
      console.log('Trading hours saved successfully:', response);
      return response;
    } catch (error) {
      console.error('Error saving trading hours:', error);
      throw error;
    }
  },
  
  /**
   * Load trading hours configuration
   */
  loadTradingHours: async () => {
    try {
      console.log('Loading trading hours from API...');
      const response = await calculatorApi.getTradingHours();
      console.log('Trading hours loaded successfully:', response);
      return response;
    } catch (error) {
      console.error('Error loading trading hours:', error);
      throw error;
    }
  },

  /**
   * Calculate trading hours totals
   * @param {Object} data - Trading hours data
   */
  calculateTradingHours: async (data) => {
    try {
      console.log('Calculating trading hours via API:', data);
      const response = await calculatorApi.calculateTradingHours(data);
      console.log('Trading hours calculated:', response);
      return response;
    } catch (error) {
      console.error('Error calculating trading hours:', error);
      throw error;
    }
  }
};

export default tradingHoursService;
